import React from 'react';
import ViewerWrapper from './ViewerWrapper';
import classNames from 'classnames';
import Loading from '../Loading';
import WordMapper from './WordMapper';

/**
 * Export a component that render the page image
 * and a map-overlay with area tags for all the words.
 */

const Viewer = ({ displayedPage, withFormFields, fieldToBeUpdated, mixPages }) => {
	return (
		<>
			{(!mixPages?.[displayedPage]?.pageUrl) && <Loading style={{ height: '100%', padding: '65% 0' }} />}
			{Object.keys(mixPages).map((page) => {
				const classes = classNames('w-100', page !== displayedPage.toString() && 'd-none', mixPages[page].isDeleted && 'blur-image');

				if (withFormFields) return <WordMapper key={page} classes={classes} page={mixPages[page]} fieldToBeUpdated={fieldToBeUpdated} />;

				return <img key={page} className={classes} src={mixPages[page].pageUrl} alt={`page-number-${page}`} onError={(e) => (e.target.alt = 'Das Bild kann nicht gefunden werden!')} />;
			})}
		</>
	);
};

export default ViewerWrapper(Viewer);
